var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import useImage from '../../../../core/hooks/useImage';
import useCommunity from '../../../../social/hooks/useCommunity';
import UICommunityCard from './UICommunityCard';
const CommunityCard = (_a) => {
    var { communityId, onClick } = _a, props = __rest(_a, ["communityId", "onClick"]);
    const { community, file, communityCategories, joinCommunity } = useCommunity(communityId);
    const { fileId } = file;
    const fileUrl = useImage({ fileId });
    const { membersCount, description, isJoined } = community;
    return (React.createElement(UICommunityCard, Object.assign({ avatarFileUrl: fileUrl, communityId: communityId, communityCategories: communityCategories, membersCount: membersCount, description: description, isOfficial: community.isOfficial, isPublic: community.isPublic, name: community.displayName, onClick: onClick, onClickJoin: joinCommunity, isJoining: false, isJoined: isJoined }, props)));
};
CommunityCard.propTypes = {
    communityId: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
};
export default memo(CommunityCard);
//# sourceMappingURL=index.js.map